import React, { Component } from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import withTranslations from '../../translations/index';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  sendAnswer,
  setActionMode,
  clearChangedOptions,
  getSectionQuestions,
  sendFaultyPartsEmails,
  faultyPartsNotifyTeam,
} from '../../actions/form';

import SubHeader from '../SubHeader/SubHeader';
import ActionMode from '../ActionMode/ActionMode';
import FormSection from './FormSection/FormSection';

import {
  rootUrl,
  uploadFileUrl,
  uploadFileLockedJobUrl,
  updateFileUrl,
  rotateImageUrl,
  rotateImageLockedJobUrl,
} from '../../constants/urls';

import {
  headerHeight,
  subHeaderHeight,
} from '../../constants/styles';

import {
  QuestionSectionNames
} from '../../views/SingleJob/constants';

import {
  isValidValue,
} from '../../utils/validations';

import {
  Button,
  Loader,
} from '../../components/base';

import { getSAPCauseCodes } from '../../constants/urls';

import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  form: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  sectionsContainer: {
    padding: 0,
    marginLeft: 0,
    maxWidth: '100%',

    '&.addJob': {
      margin: `calc(${headerHeight}px + ${subHeaderHeight}px) 0 0`,
      padding: theme.spacing(),
      paddingTop: theme.spacing(3),
    },

    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1.5),

      '&.addJob': {
        padding: theme.spacing(3),
      },
    },
  },

  submitButton: {
    position: 'fixed',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
      height: 64,
      width: 128,
      marginRight: 0,
      zIndex: 1000,
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
      height: 64,
      width: 64,
      borderRadius: '50%',
      marginRight: 0,
      zIndex: 1000,
    },
  },

  secondaryButtonLabel: {
    color: theme.palette.primary.main,
    fontSize: theme.typography.body1.fontSize,
  },
  amContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
  },
  amButton: {
    minWidth: 100,
    width: '50%',
    padding: theme.spacing(),

    [theme.breakpoints.up('sm')]: {
      width: '30%',
    },
  },
  loader: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    color: theme.palette.secondary.main,
  },
})

const isSuperset = (set, subset) => {
  if (set === null || subset === null) { return false; }
  const packedSubSet = Array.isArray(subset)
    ? subset
    : [subset];
  if (packedSubSet.length === 0) return false;
  for (let e of packedSubSet) {
    if (!set.includes(e)) {
      return false
    }
  }
  return true
}

class SectionedForm extends Component {
  state = {
    answersFetched: false,
    formInitiallyEvaluated: false,
    formSections: [],
    fields: [],
    oldAnswers: {},
    answers: {},
    errors: {},
    conditionHasChanged: 0,
    changedFields: [],
    isValid: true,
  }

  componentDidMount() {
    this.getFormData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.formSections.length || this.areLabelsSame(prevProps.formSections, this.props.formSections)) {
      this.getFormData();
    }

    if (this.props.changedOptions.length) {
      this.props.changedOptions.map(fieldKey => this.state.answers[fieldKey] ? this.handleFieldChange(fieldKey, null) : null)
      this.props.actions.clearChangedOptions();
    }
  }

  setSAPCauseCodes = async answer => {
    await this.props.actions.sendAnswer(getSAPCauseCodes(this.props.job.id), answer , true);

    let fields = this.state.fields;
    fields.map(field => field.key  === 'StripObservation_SAPCauseCode' ? field.options = this.props.options.StripObservation_SAPCauseCode : true);
  }

  areLabelsSame = (prevFormSections, formSections) => {
    let areSame = true

    prevFormSections.forEach(pfs => {
      const differentFS = formSections.find(fs => fs.key === pfs.key && fs.label !== pfs.label)
      areSame = !!differentFS
    })

    return areSame
  }

  shouldSubmitForm = () => !this.props.isSubmitting && (this.state.changedFields.length || this.props.formType);

  repopulateQuestionAnswerSessionData = (section, jobId) => {
    const questionAnswerSession = JSON.parse(sessionStorage.getItem('questionAnswerSession'));

    questionAnswerSession
      && questionAnswerSession[jobId]
      && questionAnswerSession[jobId][section]
      && questionAnswerSession[jobId][section].answers
      && this.setState(
        prevState => ({ answers: questionAnswerSession[jobId][section].answers, oldAnswers: prevState.oldAnswers }),
        () => Object.keys(this.state.answers).map(key => this.updateChangedFields(key, this.state.answers[key]))
      );
  }

  openActionMode = async () => {
    this.shouldSubmitForm() && await this.onFormSubmit();
    // Open ActionMode only if test assessment has not changed.
    // In that case job will be auto re-fetched.

    if (!this.state.changedFields.includes('ProductEvaluation_TestAssessment')) {
      this.props.actions.setActionMode(true);
      this.repopulateQuestionAnswerSessionData(this.props.formName, this.props.job.id);
    }
  }

  getFormData = async () => {
    const { formSections } = this.props;

    this.setState({
      formInitiallyEvaluated: false,
      answersFetched: false
    })

    // Save formSections, then evaluate all conditions, and set corresponding flags to true
    await this.setState(
      { formSections },
      async () => {
        await this.getFormFieldsAndAnswers();
        await this.evaluateAllConditionsAndUpdate();
        this.setState({formInitiallyEvaluated: true})
        this.setState({answersFetched: true})
      }
    )
  }

  setAnswers = answers => {
    this.setState({ answers, changedFields: []})
  }

  // Get form fields: in case there is 'fields' key in section, get questions from it. Otherwise, it is already a question.
  // Get oldAnswers and current answers
  getFormFieldsAndAnswers = () => {
    const { formSections } = this.state;
    const fields = formSections && formSections.reduce((acc, section) => section.fields ? [...acc, section, ...section.fields] : [...acc, section], [])

    this.setState({fields})

    fields && fields.map(
      field => this.setState(prevState => ({
          answers: Object.assign({}, prevState.answers, {[field.key]: field.answer || null}),
          oldAnswers: Object.assign({}, prevState.oldAnswers, {[field.key]: field.answer || null})
      }),
      () => this.props.job && this.repopulateQuestionAnswerSessionData(this.props.formName, this.props.job.id))
    );

    return true;
  }

  generateSessionAnswersData = (jobId, section) => {
    let questionAnswerSession = JSON.parse(sessionStorage.getItem('questionAnswerSession'));
    if (!questionAnswerSession) {
      questionAnswerSession = { [jobId]: { [section]: { answers: this.state.answers }}};
    } else if (!questionAnswerSession[jobId]) {
      questionAnswerSession = { ...questionAnswerSession, [jobId]: { [section]: { answers: this.state.answers }}};
    } else if (!questionAnswerSession[jobId][section]) {
      questionAnswerSession[jobId] = { ...questionAnswerSession[jobId], [section]: { answers: this.state.answers }};
    } else if(!questionAnswerSession[jobId][section].answers) {
      questionAnswerSession[jobId][section].answers = this.state.answers;
    } else {
      questionAnswerSession[jobId][section].answers = this.state.answers;
    }

    sessionStorage.setItem('questionAnswerSession', JSON.stringify(questionAnswerSession));
  }

  isDynamicQuestionsForm = formName => Object.values(QuestionSectionNames).indexOf(formName) !== -1;

  // Save answer, then evaluate all conditions (if field is relevant), and keep track of changed fields
  // This is done in SectionedForm instead of FormSection because a field can be depending of
  // a field from another section
  handleFieldChange = (key, value, field = null, isRelevantTypeForEvaluation = true, shouldSubmitForm = false) => {
    if (value !== this.state.answers[key]) {
      this.setState(prevState =>
        ({ answers: Object.assign({}, prevState.answers, { [key]: value }) }),
        () => {
          this.updateChangedFields(key, value);

          if (isRelevantTypeForEvaluation) {
            // If the form is Add Job and if we're missing field param,
            // we're checking all condtions.
            if (field && !this.props.formType) {
              this.evaluateDependantConditionsAndUpdate(field)
            } else {
              this.evaluateAllConditionsAndUpdate()
            }
          }

          shouldSubmitForm && this.onFormSubmit();

          const { formName, job } = this.props;
          this.isDynamicQuestionsForm(formName) && this.generateSessionAnswersData(job.id, formName);
        }
      );
    }
  }

  // Check if there are unanswered required questions
  hasMissingFields = () =>
    !this.state.fields
      .filter(field => field.required === true && !field.shouldHide)
      .reduce((acc, field) => acc && this.state.answers[field.key], true)

  validateField = (field, currentValue = null) => {
    const { control, key, required, type, minLength, maxLength, shouldHide } = field;
    const value = currentValue || this.state.answers[key];
    const fieldNotImportant = !required && !value;
    const hasError = fieldNotImportant && !shouldHide ? false : !isValidValue(value, control, type, minLength, maxLength);

    this.setState(prevState =>
      ({errors: Object.assign({}, prevState.errors, {[key]: hasError})}),
      () => this.setState({isValid: Object.values(this.state.errors).reduce((acc, val) => acc && !val, true)})
    );

    return !hasError;
  }

  validateForm = () => this.state.fields.map(field => this.validateField(field));

  onFormSubmit = async e => {
    e && e.preventDefault();

    if (this.shouldSubmitForm()) {
      // Validate form and submit
      await this.validateForm();

      if (this.state.isValid) {
        const hasTestAssessmentChanged = this.state.changedFields.find(field => field.toLowerCase().includes('testassessment'))
        // Send only new / changed answers
        const changedAnswers = this.state.changedFields.reduce((acc, field) => ({...acc, [field]: this.state.answers[field]}), {})

        await this.props.onSubmit(changedAnswers, hasTestAssessmentChanged);
        this.forceUpdate();
        // Remove this form from the updated forms, and remove all fields from the changedFields
        this.setState(
          { formSections: [] },
          () => {
            this.setState({changedFields: []});
            return this.props.updateChangedSections
            ? this.props.updateChangedSections(this.props.formName, 'remove')
            : null
          }
        );
      }
    }
  }

  // Track if the form has been changed, so we can inform users if the form is not saved,
  // and skip unnecessary submit
  updateChangedFields = (key, value) => {
    // Remove the key from the changed arr if the field was changed,
    // and then changed back tothe starting value
    if (this.state.changedFields.includes(key)) {
      if (this.state.oldAnswers[key] === value) {
        return this.setState(prevState =>
          ({ changedFields: prevState.changedFields.filter(field => field !== key) }),
          () => this.props.updateChangedSections
                ? this.props.updateChangedSections(this.props.formName, 'remove')
                : null
        )
      }
      return;
    // Add the key to the changed array only if it isn't already there, and the value was changed
    // compared to the initial form value.
    } else {
      if (this.state.oldAnswers[key] !== value) {
        return this.setState(prevState =>
          ({ changedFields: [...prevState.changedFields, key] }),
          () => this.props.updateChangedSections
                ? this.props.updateChangedSections(this.props.formName, 'add')
                : null
        )
      }
      return;
    }
  }

  // Evaluate condition and set shouldHide flag if condition is not met
  evaluateCondition(field) {
    let { condition, conditions, key } = field;

    const fieldNames = this.state.fields.reduce((acc, field) => [...acc, field.key], []);
    // Reference to the field(s) in the current job, only if we have access to it.
    if (this.props.job) {
      // eslint-disable-next-line no-unused-vars
      const { reportLevel, testAssessment, customerNumber, customerCenterPlantCode, serviceTechnologyCenterPlannerGroup } = this.props.job;
    }

    if (condition && fieldNames.length) {
      fieldNames.map(fieldName => {
        if (condition.includes(fieldName) && !condition.includes(`this.state.answers.${fieldName}`)) {
          condition = condition.replace(new RegExp(fieldName, 'g'), `this.state.answers.${fieldName}`);
        }

        return null;
      })

      let shouldHide = true;
      if (conditions) {
        conditions.forEach(cond => {
          if (this.state.answers[cond.property] !== undefined) {
            shouldHide = shouldHide && isSuperset(cond.values, this.state.answers[cond.property]);
          } else if (this.props.job[cond.property] !== undefined) {
            shouldHide = shouldHide && isSuperset(cond.values, this.props.job[cond.property]);
          } else if (cond.property !== undefined) {
            shouldHide = shouldHide && isSuperset(cond.values, cond.property);
          }
        });
      }

      // Based on evaluation of condition, set shouldHide prop on a field.
      // eslint-disable-next-line no-eval
      field.shouldHide = !shouldHide;

      // Set the answer to null if condition evaluates to false. Null value is sent to BE.
      if (field.shouldHide && this.state.answers[key] != null) {
        this.setState(prevState =>
          ({ answers: Object.assign({}, prevState.answers, {[key]: null})}),
          () => this.updateChangedFields(key, null)
        )
      }

      // Remove existing values from children of a subsection that should not be displayed
      if (field.shouldHide && field.type === 'subsection' && field.fields && field.fields.length) {
        field.fields.map(({key}) => {
          return this.setState(prevState =>
            ({ answers: Object.assign({}, prevState.answers, {[key]: null})}),
            () => this.updateChangedFields(key, null)
          )
        })
      }
    }
  }

  // Prepare fields to be sent to evaluateCondition method
  evaluateFieldConditions = fieldsArray =>
    fieldsArray.map(section => {
      if (section.condition) this.evaluateCondition.call(this, section);

      section.fields
      ? section.fields.map(field => this.evaluateCondition.call(this, field))
      : this.evaluateCondition.call(this, section)
      return section;
    })

  // Evaluate all conditions and update if needed
  evaluateAllConditionsAndUpdate = async () => {
    await this.evaluateFieldConditions(this.state.formSections)

    // Force Component update if at least one field has changed its shouldHide value
    this.setState(prevState => ({
      conditionHasChanged: prevState.conditionHasChanged > 1000
        ? 1
        : prevState.conditionHasChanged += 1
      }));

    return true;
  }

  // Evaluate conditions for dependant fields only.
  evaluateDependantConditionsAndUpdate = field => {
    if (field.dependantKeys && field.dependantKeys.length) {
      field.dependantKeys.map(key => {
        const fieldToEvaluate = this.state.fields.find(field => field.key === key);

        fieldToEvaluate && this.evaluateCondition(fieldToEvaluate);

        // Force Component update if at least one field has changed its shouldHide value
        this.setState(prevState => ({
          conditionHasChanged: prevState.conditionHasChanged > 1000
            ? 1
            : prevState.conditionHasChanged += 1
          }));

        return true;
      })
    }
  }

  isFormSubmitDisabled = (job, section) => job && ((job.locked && section !== QuestionSectionNames.CONFORMITY_TEST) || this.props.isSubmitting || !this.state.changedFields.length);
  isActionModeDisabled = (job, section) => job && ((job.locked && section !== QuestionSectionNames.CONFORMITY_TEST) || this.props.isSubmitting);

  render() {
    const {
      classes: c,
      formTranslations: t,
      gt,
      validateForm,
      formType,
      formName,
      job,
      user,
      options,
      hasActionMode,
      isSubmitting,
    } = this.props;

    const { errors, answers, answersFetched, formSections, oldAnswers,
      formInitiallyEvaluated, conditionHasChanged, changedFields, fields } = this.state;

    const uploadUrl = formName === QuestionSectionNames.CONFORMITY_TEST
      ? uploadFileLockedJobUrl
      : uploadFileUrl;

    const rotateUrl = formName === QuestionSectionNames.CONFORMITY_TEST
      ? rotateImageLockedJobUrl
      : rotateImageUrl;

    if (answersFetched && formInitiallyEvaluated && formSections.length) {
      // Split visible sections in two (eg. for 7 sections it's 4 + 3)
      const visibleSections = formSections.filter(section => !section.shouldHide);
      const splitAfter = Math.ceil(visibleSections.length / 2);
      const firstColumn = visibleSections.slice(0, splitAfter);
      const secondColumn = visibleSections.slice(splitAfter);
      return (
        <form onSubmit={this.onFormSubmit} className={c.form}>
          {
            formType &&
            <SubHeader
              styles={{...c.header, ...c.cancelButton, ...c.title, ...c.actionButton}}
              translations={{title: t.title, actionButton: t.button, createdAt: t.createdAt}}
              actionButton={{condition: true, disabled: this.hasMissingFields(), type: 'submit'}}
              cancelButton={{route: rootUrl()}}
              view={formType}
            />
          }
          {
            hasActionMode && (window.screen.width > 600 || window.screen.height > 600) &&
            <div className={c.amContainer}>
              <Button
                onClick={this.openActionMode}
                className={c.amButton}
                disabled={this.isActionModeDisabled(job, formName)}
                variant='contained' color='secondary'
              >
                {gt.actionMode}
              </Button>
            </div>
          }

          <Grid className={classNames(c.sectionsContainer, `${formType || ''}`)} container spacing={3}>
              {[firstColumn, secondColumn].map((column, i) =>
                <Grid item md={6} xs={12} key={i}>
                  {column.map(section =>
                    <FormSection
                      id={job ? job.id : null}
                      user={user}
                      shouldUpdate={conditionHasChanged}
                      key={section.key}
                      handleFieldChange={this.handleFieldChange}
                      validateForm={validateForm}
                      data={section}
                      answers={answers}
                      errors={errors}
                      formName={formName}
                      formType={formType}
                      uploadEndpoint={job ? uploadUrl(job.id) : null}
                      updateFileEndpoint={job ? updateFileUrl(job.id) : null}
                      rotateImageEndpoint={job ? rotateUrl(job.id) : null}
                      isLocked={job ? job.locked : false}
                      sendAnswerAction={this.props.actions.sendAnswer}
                      sendFaultyPartsEmailsAction={this.props.actions.sendFaultyPartsEmails}
                      faultyPartsNotifyTeamAction={this.props.actions.faultyPartsNotifyTeam}
                      options={options}
                      validateField={formType ? this.validateField : null}
                      shouldSaveForm={!this.isFormSubmitDisabled(job, formName)}
                      getSectionQuestions={this.props.actions.getSectionQuestions}
                      submitForm={this.onFormSubmit}
                    />
                  )}
                </Grid>
              )}
          </Grid>
          {
            !formType &&
            <Button
              className={c.submitButton}
              type='submit'
              variant='contained'
              color='secondary'
              disabled={this.isFormSubmitDisabled(job, formName)}
            >
              <span className={c.secondaryButtonLabel}>{gt.save}</span>
            </Button>
          }

          {
            this.props.isActionMode &&
            <ActionMode
              jobId={job ? job.id: null}
              handleClose={() => this.props.actions.setActionMode(false)}
              title={formName}
              data={formSections}
              answers={answers}
              oldAnswers={oldAnswers}
              handleFieldChange={this.handleFieldChange}
              submitForm={this.onFormSubmit}
              shouldSubmit={changedFields.length !== 0}
              changedFields={changedFields}
              isSubmitting={isSubmitting}
              uploadEndpoint={job ? uploadUrl(job.id) : null}
              updateFileEndpoint={job ? updateFileUrl(job.id) : null}
              rotateImageEndpoint={job ? rotateUrl(job.id) : null}
              formTranslations={t}
              fields={fields}
              setAnswers={this.setAnswers}
              onFormSubmit={this.onFormSubmit}
              updateChangedForms={this.props.updateChangedForms}
              setSAPCauseCodes={this.setSAPCauseCodes}
            />
          }
        </form>
      );
    } else {
      return <Loader className={c.loader}/>
    }
  }
}

const mapStateToProps = state => ({
  options: state.form.options,
  changedOptions: state.form.changedOptions,
  isActionMode: state.form.isActionMode,
})

const mapDispatchToProps = dispatch => ({
  actions: {
    sendAnswer: bindActionCreators(sendAnswer, dispatch),
    clearChangedOptions: bindActionCreators(clearChangedOptions, dispatch),
    setActionMode: bindActionCreators(setActionMode, dispatch),
    getSectionQuestions: bindActionCreators(getSectionQuestions, dispatch),
    sendFaultyPartsEmails: bindActionCreators(sendFaultyPartsEmails, dispatch),
    faultyPartsNotifyTeam: bindActionCreators(faultyPartsNotifyTeam, dispatch),
  }
})

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(withTranslations(SectionedForm, 'SectionedForm')));



// WEBPACK FOOTER //
// ./src/components/SectionedForm/SectionedForm.js